import PropTypes from 'prop-types';

import { formatData } from '@utilities';

import styles from './_index.module.scss';

const SampleSizeFooter = ({ sampleSizes }) => {
  if (!sampleSizes || !sampleSizes.data || !sampleSizes.name) return null;
  return (
    <div className={styles['sample-size-footer']}>
      <h3>{sampleSizes.name}</h3>
      <ul>
        {sampleSizes.data?.map(([label, value], index) => (
          <li key={`sample-size-${index}`}>
            <span>{label}</span>
            <span>{formatData({ value })}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

SampleSizeFooter.propTypes = {
  sampleSizes: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
    ),
    name: PropTypes.string,
  }),
};

export default SampleSizeFooter;
